var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { customElement, property, state, } from 'lit/decorators.js';
import { v4 as uuidv4 } from 'uuid';
// @ts-ignore
import * as L from 'leaflet/dist/leaflet-src.esm.js';
import { updateWhenLocaleChanges, msg } from '@lit/localize';
import { ZoomControl } from './controls/zoomControl';
import { ScaleControl } from './controls/scaleControl';
import { WmsRequest } from './controls/serviceControl';
import { LayersManager } from './controls/layersManager/layersManager';
import { LayersValidator } from './controls/layersManager/layersValidator';
import { BaseShadowless } from '../indicator/BaseShadowless';
import { LayersChangeDetector } from './controls/layersManager/layersChangeDetector';
import { LayerInfo } from './controls/layersManager';
import { PluginManager } from './controls/plugins/pluginManager';
/**
 * Represents the map component
 */
let DinapsisMap = class DinapsisMap extends BaseShadowless {
    constructor() {
        super();
        /**
         * A property that is used to generate unique id
         */
        this.mapUuid = uuidv4();
        /**
         * A property that is used to generate the constructor of zoomControlHandler
         */
        this.zoomControlHandler = new ZoomControl();
        /**
         * A property that is used to generate the constructor of scaleControlHandler
         */
        this.scaleControlHandler = new ScaleControl();
        /**
         * A property that is used to manage class of layersManager
         */
        this.layersManager = new LayersManager();
        /**
         * A Property that is used to center map view if not exist layer
         * and center property
         */
        this.defaultCenterMap = [38.345749, -0.490964];
        /**
         * Flag used to know if map has already been centered in an overlay layer.
         * We only center in an overlay layer once.
         */
        this.mapCenteredOnOverlay = false;
        /**
         * Varibla that stores last opacity received
         */
        this.lastOpacityReceived = -1;
        /**
         * A property that is used to center map view
         */
        this.center = [];
        /**
         * A property that is used to enable the zoomControl
         */
        this.zoomControl = false;
        /**
       * A property that is used to enable the scaleControl
       */
        this.scaleControl = false;
        /**
         * A property that is used to enable the baseMapControl
         */
        this.baseMapControl = false;
        /**
         * A property that is used to set the min zoom map level
         */
        this.zoomMinLevel = 1;
        /**
         * A property that is used to set the max zoom map level
         */
        this.zoomMaxLevel = 20;
        /**
         * A property that is used to force zoom in map to be done pressing control key
         * at the same time that user moves mouse wheel
         */
        this.zoomOnlyWithControlKey = false;
        /**
         * A property that is used to set the type of selection mode
         */
        this.selectionMode = '';
        /**
         * A property that is used to set the base layers which map load
         */
        this.baseLayer = [];
        /**
         * A property that is used to load the overlay layers of map
         */
        this.overlayLayers = [];
        /**
           * The options of the menu that should be shown for each layer.
           */
        this.layerToolbarConfig = {
            showVisibility: true,
            showOpacity: true,
            showDelete: true,
        };
        /**
         * A property that is used to set the height of map
         */
        this.height = '100%';
        /**
         * A property that is used to set the width of map
         */
        this.width = '100%';
        /**
         * A property that is used to enable the timeControl
         */
        this.timeControl = false;
        /**
         * A property that is used to load the array of items of time control
         */
        this.timeControlData = [];
        updateWhenLocaleChanges(this);
    }
    /**
     * Lit lifecycle function executed before update
     * @param changed Te info of te properties changed
     */
    willUpdate(changed) {
        if (changed.has('baseLayer')) {
            this.validateBaseLayers();
        }
        if (changed.has('overlayLayers')) {
            this.validateOverlayLayers();
        }
    }
    /**
     * The above function is a lifecycle hook that is called when the component is first updated.
     * It is used to initialize the tree view.
     */
    firstUpdated() {
        this.initMap();
        this.setBaseMapControl();
        this.centerMap();
        this.emitEventMap();
        this.emitEventMapLoaded();
    }
    /**
     * If any property has changed when finish update this method is called an
     * depending on wich property has been modified,
     * it executes its update method
     * @param changedProperties - Map<string, unknown>
     */
    updated(changedProperties) {
        if (changedProperties.has('zoomMinLevel') || changedProperties.has('zoomMaxLevel')) {
            this.refreshMapZoomLevelInterval();
        }
        if (changedProperties.has('overlayLayers')) {
            const changeDetector = new LayersChangeDetector();
            const { added, removed, modified } = changeDetector.getChanges(this.overlayLayers, changedProperties.get('overlayLayers') ? changedProperties.get('overlayLayers') : []);
            this.overlayLayers.forEach((layer) => {
                this.createPane(layer.id);
            });
            this.layersManager.addOverlayLayers(added);
            this.layersManager.removeOverlayLayers(removed);
            this.layersManager.manageOverlayLayersChanges(modified);
            // Update the layer order (zIndex) in map
            this.layersManager.updateLayerOrder(this.overlayLayers);
        }
        if (changedProperties.has('zoomControl')) {
            this.hasZoomControl();
        }
        if (changedProperties.has('scaleControl')) {
            this.hasScaleControl();
        }
    }
    createPane(paneId) {
        let pane = this.map.getPane(paneId);
        if (pane === undefined) {
            pane = this.map.createPane(paneId);
            pane.id = paneId;
        }
    }
    /**
     * The createRenderRoot function is a function that is called by the lit-html library to tell the
     * component where to render the html.
     * @returns The element itself.
     */
    createRenderRoot() {
        return this;
    }
    /**
     * Method that returns the state of current overlay layers
     * It could be used from the application that uses dinapsis map.
     * @returns The overlay layers with their current state.
     */
    getOverlayLayers() {
        return this.overlayLayers;
    }
    /**
     * Fit zoom and center to given bounds. Can be called from vertical application.
     * @param SWLat SouthWest latitude
     * @param SWLong SouthWest Longitude
     * @param NELat NorthEast latitude
     * @param NELong NorthEast Longitude
     */
    fitBounds(SWLat, SWLong, NELat, NELong) {
        const southWest = L.latLng(SWLat, SWLong);
        const northEast = L.latLng(NELat, NELong);
        const layerBounds = L.latLngBounds(southWest, northEast);
        this.map.fitBounds(layerBounds);
    }
    /**
     * A function that center the map to the first layer bounding box if the parameter
     * center is not send.
     */
    async centerMap() {
        if (this.center.length > 0)
            return;
        if (!this.mapCenteredOnOverlay && this.overlayLayers && this.overlayLayers.length > 0) {
            const bounds = await LayerInfo.getBounds(this.overlayLayers[0]);
            if (bounds) {
                this.map.fitBounds(bounds);
                this.emitEventMapCentered(bounds);
                this.mapCenteredOnOverlay = true;
            }
        }
    }
    /**
     * Center the map on layer passed on event respecting the map zoom.
     * @param ev Event with layer detail
     */
    async centerMapOn(ev) {
        const { layer } = ev.detail;
        if (layer.center) {
            const zoom = this.map.getZoom();
            let bounds = await LayerInfo.getBounds(layer);
            if (bounds === null) {
                const southWest = L.latLng(layer.bbox.south, layer.bbox.west);
                const northEast = L.latLng(layer.bbox.north, layer.bbox.east);
                bounds = L.latLngBounds(southWest, northEast);
            }
            // Set center from bounds and zoom
            this.map.setView(bounds.getCenter(), zoom);
            // Emit event
            this.dispatchEvent(new CustomEvent('center-on', { detail: { layer } }));
        }
    }
    /**
     * Creates layer objects from plain objects that come from properties
     * and validate plain object has the correct data.
     */
    validateBaseLayers() {
        const layersValidator = new LayersValidator();
        layersValidator.validateBaseLayers(this.baseLayer);
    }
    /**
     * Creates layer objects from plain objects that come from properties
     * and validate plain object has the correct data.
     */
    validateOverlayLayers() {
        const layersValidator = new LayersValidator();
        layersValidator.validateOverlayLayers(this.overlayLayers);
        // Look for duplicated ids
        const ids = this.overlayLayers.map((oL) => oL.id);
        const duplicated = ids.filter((id, index) => ids.indexOf(id) !== index);
        if (duplicated && duplicated.length > 0) {
            throw new Error(`There are duplicated ids in overlayLayers: ${ids.join(', ')}`);
        }
    }
    /**
     * If the zoomControl property is true, create a zoom control and add it to the map.
     * @returns the zoomControl variable.
     */
    hasZoomControl() {
        if (!this.zoomControl) {
            this.zoomControlHandler.removeZoomControl();
            return;
        }
        if (this.zoomControlHandler.object)
            return;
        const zoomControl = this.zoomControlHandler.createZoomControl();
        zoomControl.addTo(this.map);
    }
    /**
     * If the scaleControl property is true, create a scale control and add it to the map.
     * @returns the scaleControl variable.
     */
    hasScaleControl() {
        if (!this.scaleControl) {
            this.scaleControlHandler.removeScaleControl();
            return;
        }
        if (this.scaleControlHandler.object)
            return;
        const scaleControl = this.scaleControlHandler.createScaleControl();
        scaleControl.addTo(this.map);
    }
    /**
     * This function create the map control if the baseMapControl es true
     * @param baseLayers - Is an object with the baseLayers to the base map control
     */
    setBaseMapControl() {
        this.layersManager.createControler(this.map, this.baseLayer);
    }
    /**
     * This function initializes the map and sets the click event.
     */
    initMap() {
        const mapDomElement = this.renderRoot.querySelector(`[data-id="map-${this.mapUuid}"]`);
        // Initialize leaflet map plugins
        const pluginManager = new PluginManager();
        pluginManager.initializeLeafletGestureHandlePlugin(this.zoomOnlyWithControlKey);
        const mapOptions = this.getMapOptions();
        this.map = L.map(mapDomElement, mapOptions);
        // Emit event map-loaded when leaflet map is initialized
        this.map.on('load', () => {
            this.emitEventMapLoaded();
        });
        const resizeObserver = new ResizeObserver(() => {
            this.map.invalidateSize();
        });
        resizeObserver.observe(mapDomElement);
        this.setMapClickEvent();
    }
    /**
     * If the map and the selection mode are both point, then when the map is clicked, the click
     * location is set to the latlng of the click event, and the click-map event is dispatched
     * with the click location as the detail.
     */
    setMapClickEvent() {
        if (this.selectionMode === 'point') {
            this.map.on('click', (e) => {
                this.getFeatureInfo(e);
            });
        }
    }
    /**
     * "When the user clicks on the map, get the feature info
     * for each layer and then emit an event with
     * the click location and the feature info for each layer."
     *
     * The function is called from the template:
     * @param {LeafletMouseEvent} e - LeafletMouseEvent - this is the event that is triggered when the
     * user clicks on the map.
     */
    async getFeatureInfo(e) {
        const featureCollections = [];
        const clickLocation = e.latlng;
        const layersFeatureGetter = this.overlayLayers.map(async (layer) => {
            if (layer.selectable) {
                const featureInfo = await WmsRequest.getFeatureInfo(this.map, clickLocation, layer);
                featureCollections.push(featureInfo);
            }
        });
        await Promise.all(layersFeatureGetter).then(() => {
            this.eventClickMap({ coords: clickLocation, featureCollections });
        });
    }
    /**
     * The function takes an object as an argument, and then dispatches a custom event with the same
     * object as the detail
     * @param {object} response - object - The response object from the FeatureInfo.
     */
    eventClickMap(response) {
        this.dispatchEvent(new CustomEvent('click-map', { detail: { ...response } }));
    }
    /**
     * When the map is ready, emit an event with the map object.
     */
    emitEventMap() {
        this.dispatchEvent(new CustomEvent('get-map', { detail: { map: this.map, mapInstance: L } }));
    }
    /**
     * When the map is ready, emit an event with the map object.
     */
    emitEventMapLoaded() {
        this.dispatchEvent(new CustomEvent('map-loaded', { detail: { map: this.map } }));
    }
    /**
     * When the map is centered by overlay layer, emit an event with the map object.
     */
    emitEventMapCentered(bounds) {
        this.dispatchEvent(new CustomEvent('map-centered', { detail: { bounds } }));
    }
    /**
     * When the visibility of a layer changes, emit an event
     * @param layerId Id of the layer
     * @param isVisible If layer is visible or not
     * @param subLayerId For custom layers we can change subLayer visibility.
     * So we inform of the subLayer in case it was a sublayer visibility change
     */
    emitChangeVisibility(layerId, isVisible, subLayerId) {
        this.dispatchEvent(new CustomEvent('change-visibility', { detail: { layerId, isVisible, subLayerId } }));
    }
    /**
     * When selected base layer changes, emit an event
     * @param baseLayerId Id of the base layer selected.
     */
    emitChangeBaseLayerSelected(baseLayerId) {
        this.dispatchEvent(new CustomEvent('change-base-layer-selected', { detail: { baseLayerId } }));
    }
    /**
     * When a layer is deleted, emit an event.
     * @param layerId Id of the layer
     */
    emitDeleteOverlayLayer(layerId) {
        this.dispatchEvent(new CustomEvent('delete-overlay-layer', { detail: { layerId } }));
    }
    /**
     * When the opacity of a layer changes, emit an event
     * @param layerId Id of the layer
     * @param value opacity of the layer
     */
    emitChangeOpacity(layerId, value) {
        // Function that checks if opacity hasn't changed in some time
        const launchEvent = () => {
            // Launch event only if opacity hasn't changed
            if (this.lastOpacityReceived === value) {
                this.dispatchEvent(new CustomEvent('change-opacity', { detail: { layerId, value } }));
            }
        };
        // Store new opacity received
        this.lastOpacityReceived = value;
        // Check after 500 ms if opacity hasn't changed
        setTimeout(launchEvent, 500);
    }
    /**
     * This function returns an object that contains the center of the map and the zoom level.
     * @returns The options object.
     */
    getMapOptions() {
        const zoomLevelOpts = this.getZoomLevel();
        const getCenter = this.center.length === 0 ? this.defaultCenterMap : this.center;
        const options = {
            center: L.latLng(getCenter),
            zoom: 13,
            zoomControl: false,
            ...zoomLevelOpts,
            // When using scale control we want to have a zoomSnap
            // (minimum zoom step for setZoom function) to 0. This way
            // we see changes in zoom when user sets small changes in scale values
            zoomSnap: this.scaleControl ? 0 : undefined,
            // If we want to allow user to change zoom only if he is pressing control key
            // From plugin https://github.com/elmarquis/Leaflet.GestureHandling
            gestureHandling: this.zoomOnlyWithControlKey ? true : undefined,
            gestureHandlingOptions: this.zoomOnlyWithControlKey ? {
                duration: 1000,
                text: {
                    touch: msg('map.touch'),
                    scroll: msg('map.scroll'),
                },
            } : undefined,
        };
        return options;
    }
    /**
     * It change the map zoom level interval
     */
    refreshMapZoomLevelInterval() {
        const { minZoom, maxZoom } = this.getZoomLevel();
        this.map.setZoom(maxZoom);
        this.map.setMinZoom(minZoom);
        this.map.setMaxZoom(maxZoom);
    }
    /**
     * This function returns an object with the min and max zoom levels.
     * @returns An object with the following properties:
     */
    getZoomLevel() {
        return ZoomControl.createMinMaxLevelOptions(this.zoomMinLevel, this.zoomMaxLevel);
    }
    changeBaseLayer(e) {
        const layerActive = e.detail.baseLayer;
        this.layersManager.changeActiveBaseLayer(layerActive);
        let selectedBaseLayer = null;
        this.baseLayer.forEach((l) => {
            const layer = l;
            const isActive = layer.id === layerActive.id;
            layer.isActive = isActive;
            if (isActive) {
                selectedBaseLayer = layer.id;
            }
            return layer;
        });
        if (selectedBaseLayer) {
            this.emitChangeBaseLayerSelected(selectedBaseLayer);
        }
    }
    /**
     * React to event of change visibility
     * @param ev Event
     */
    changeVisibility(ev) {
        const { layerId, isVisible } = ev.detail;
        // Create new array with change in visibility for the overlayLayer desired
        // We do it in order to launch reactivity to other UI components
        this.overlayLayers = this.overlayLayers
            .map((el) => (el.id === layerId ? { ...el, isVisible } : el));
        this.emitChangeVisibility(layerId, isVisible);
    }
    /**
     * React to event of change visibility
     * @param ev Event
     */
    changeVisibilityLayer(ev) {
        const { layerGroup, layerId, isVisible } = ev.detail;
        const overlayLayer = this.overlayLayers.find((oL) => oL.id === layerGroup);
        const overlayLayerVisibility = overlayLayer === null || overlayLayer === void 0 ? void 0 : overlayLayer.isVisible;
        // Create new array with change in visibility for the overlayLayer desired
        // We do it in order to launch reactivity to other UI components
        this.overlayLayers = this.overlayLayers
            .map((el) => (el.id === layerGroup ? { ...el, overlayLayerVisibility } : el));
        switch (overlayLayer === null || overlayLayer === void 0 ? void 0 : overlayLayer.type) {
            case 'OverlayCustomLayer':
                this.overlayLayers.find((oL) => oL.id === layerGroup).layers
                    .forEach((l, index) => {
                    if (l.id === layerId) {
                        overlayLayer.layers[index].isVisible = !isVisible;
                    }
                });
                break;
            default:
                break;
        }
        if (overlayLayer) {
            // Change visibility in map
            this.layersManager.removeOverlayLayerToMap(overlayLayer);
            this.layersManager.addOverlayLayerToMap(overlayLayer);
        }
        this.emitChangeVisibility(layerGroup, !isVisible, layerId);
    }
    /**
     * Delete overlay layer from layers manager.
     * @param ev Custom event info.
     */
    deleteOverlayLayer(ev) {
        const { layerId } = ev.detail;
        const layerToDelete = this.overlayLayers
            .find((item) => item.id === layerId);
        if (layerToDelete) {
            this.layersManager.removeOverlayLayers([layerToDelete]);
        }
        const indextToDelete = this.overlayLayers
            .findIndex((item) => item.id === layerId);
        this.overlayLayers = this.overlayLayers
            .filter((_, i) => i !== indextToDelete);
        this.emitDeleteOverlayLayer(layerId);
    }
    /**
     * React to event of change opacity
     * @param ev Event
     */
    changeOpacity(ev) {
        const { layerId, value } = ev.detail;
        const overlayLayer = this.overlayLayers.find((oL) => oL.id === layerId);
        if (overlayLayer) {
            overlayLayer.opacity = value;
            this.layersManager.setOverlayLayerOpacity(overlayLayer, value);
        }
        this.emitChangeOpacity(layerId, value);
    }
    /**
     * Launch event when menu option is clicker
     * @param ev Event
     */
    menuOptionClicked(ev) {
        this.dispatchEvent(new CustomEvent('option-clicked', ev));
    }
    /**
     * Event received in order to change layer order
     * @param ev The event
     */
    changeLayerOrder(ev) {
        const { layerIdMoved, newIndex } = ev.detail;
        const layerToMove = this.overlayLayers.find((el) => el.id === layerIdMoved);
        this.overlayLayers = this.overlayLayers.filter((el) => el.id !== layerIdMoved);
        if (layerToMove) {
            this.overlayLayers = [
                ...this.overlayLayers.slice(0, newIndex),
                layerToMove,
                ...this.overlayLayers.slice(newIndex, this.overlayLayers.length),
            ];
        }
        this.layersManager.updateLayerOrder(this.overlayLayers);
        // Dispatch event for application using map
        this.dispatchEvent(new CustomEvent('change-layer-order', { detail: { ...ev.detail } }));
    }
    /**
     * The function return map layer component and prepare data if this needs be rendered.
     * @returns Html that represent the component.
     */
    renderLayerManager() {
        if (this.baseMapControl) {
            return html `<dinapsis-map-layer-manager
        .mapHeight=${this.height}
        .baseLayer=${this.baseLayer}
        .overlayLayers=${this.overlayLayers}
        .layerToolbarConfig=${this.layerToolbarConfig}
        @changeBaseLayer="${this.changeBaseLayer}"
        @change-visibility="${this.changeVisibility}"
        @change-visibility-layer="${this.changeVisibilityLayer}"
        @option-clicked="${this.menuOptionClicked}"
        @change-layer-order="${this.changeLayerOrder}"
        @change-opacity="${this.changeOpacity}"
        @delete-overlay-layer="${this.deleteOverlayLayer}"
        @center-on="${this.centerMapOn}"></dinapsis-map-layer-manager>`;
        }
        return html ``;
    }
    /**
     * Event received time control updated data
     * @param ev The event
     */
    timeControlUpdate(ev) {
        this.dispatchEvent(new CustomEvent('time-control-update', { detail: { ...ev.detail } }));
    }
    /**
     * The function return time navigator component.
     * @returns Html that represent the component.
     */
    renderTimeNavigation() {
        if (this.timeControl) {
            return html `
      <dinapsis-time-navigator
        .model=${this.timeControlData}
        @change-position=${this.timeControlUpdate}
      ></dinapsis-time-navigator>
      `;
        }
        return html ``;
    }
    /**
     * The function returns a string of HTML that contains a div that contains the component.
     * @returns The return statement is returning the html template literal
     */
    render() {
        return html `
      <div class="map dinapsis-map dinapsis-map-container"  style="height: ${this.height}; width: ${this.width};">
        <div data-id="map-${this.mapUuid}" style="height: 100%; width: 100%">
          <slot></slot>
        </div>
        <div class="dinapsis-map dinapsis-map-time-container">
          ${this.renderTimeNavigation()}
        </div>
        <div>
          ${this.renderLayerManager()}
        </div>
      </div>
    `;
    }
};
__decorate([
    property({ type: Array })
], DinapsisMap.prototype, "center", void 0);
__decorate([
    state(),
    property({ type: Boolean })
], DinapsisMap.prototype, "zoomControl", void 0);
__decorate([
    state(),
    property({ type: Boolean })
], DinapsisMap.prototype, "scaleControl", void 0);
__decorate([
    state(),
    property({ type: Boolean })
], DinapsisMap.prototype, "baseMapControl", void 0);
__decorate([
    state(),
    property({ type: Number })
], DinapsisMap.prototype, "zoomMinLevel", void 0);
__decorate([
    state(),
    property({ type: Number })
], DinapsisMap.prototype, "zoomMaxLevel", void 0);
__decorate([
    property({ type: Boolean })
], DinapsisMap.prototype, "zoomOnlyWithControlKey", void 0);
__decorate([
    property({ type: String })
], DinapsisMap.prototype, "selectionMode", void 0);
__decorate([
    state(),
    property({ type: Array })
], DinapsisMap.prototype, "baseLayer", void 0);
__decorate([
    state(),
    property({ type: (Array), reflect: true })
], DinapsisMap.prototype, "overlayLayers", void 0);
__decorate([
    property({ type: Object })
], DinapsisMap.prototype, "layerToolbarConfig", void 0);
__decorate([
    state(),
    property({ type: String })
], DinapsisMap.prototype, "height", void 0);
__decorate([
    state(),
    property({ type: String })
], DinapsisMap.prototype, "width", void 0);
__decorate([
    state(),
    property({ type: Boolean })
], DinapsisMap.prototype, "timeControl", void 0);
__decorate([
    state(),
    property({ type: Array })
], DinapsisMap.prototype, "timeControlData", void 0);
DinapsisMap = __decorate([
    customElement('dinapsis-map')
], DinapsisMap);
export { DinapsisMap };
//# sourceMappingURL=dinapsis-map.js.map